<template>
  <JluButtonLink
    v-if="link"
    variant="transparent"
    size="small"
    v-bind="props"
    class="c-header-mobile-back-button"
  >
    <JluIcon variant="chevron-left" />
  </JluButtonLink>
</template>

<script>
import { JluButtonLink, JluIcon } from '@jobleads-frontend/ui_library';
import { mapGetters } from 'vuex';

export default {
  name: 'HeaderMobileBackButton',
  components: {
    JluButtonLink,
    JluIcon,
  },

  computed: {
    ...mapGetters({
      link: 'mobileBackButton/link',
    }),

    props() {
      if (!this.link) {
        return undefined;
      }

      if (typeof this.link === 'string' && this.link.startsWith('http')) {
        return {
          href: this.link,
        };
      }

      return {
        to: this.link,
      };
    },
  },
};
</script>

<style lang="scss">
.c-header-mobile-back-button {
  margin-left: -16px;
  padding: 0 8px;

  @include xsm {
    // !important is needed because of weird css order in build files
    display: none !important;
  }
}
</style>
